module.exports = "<div ktScrollTop [options]=\"scrollTopOptions\" id=\"kt_scrolltop\" class=\"kt-scrolltop\">\n\t<i class=\"la la-arrow-up\"></i>\n</div>\n"